/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpprofile_Dealstotal3Inputs */

const en_coinvestments_insights_lpprofile_dealstotal3 = /** @type {(inputs: Coinvestments_Insights_Lpprofile_Dealstotal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deals`)
};

/**
* | output |
* | --- |
* | "Deals" |
*
* @param {Coinvestments_Insights_Lpprofile_Dealstotal3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpprofile_dealstotal3 = /** @type {((inputs?: Coinvestments_Insights_Lpprofile_Dealstotal3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpprofile_Dealstotal3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpprofile_dealstotal3(inputs)
});
export { coinvestments_insights_lpprofile_dealstotal3 as "coInvestments_insights_lpProfile_dealsTotal" }